import { render, staticRenderFns } from "./PixUpdate.vue?vue&type=template&id=0f7e36ac&scoped=true"
import script from "./PixUpdate.vue?vue&type=script&lang=js"
export * from "./PixUpdate.vue?vue&type=script&lang=js"
import style0 from "./PixUpdate.vue?vue&type=style&index=0&id=0f7e36ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7e36ac",
  null
  
)

export default component.exports